import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Alert,
  Button,
  Label,
  Input,
  InputGroup,
  Form,
  Spinner,
} from "reactstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"

import Breadcrumb from "../../components/Common/Breadcrumb"
import avatar from "../../assets/images/users/avatar-1.jpg"
import { getMe, changePassword } from "../../helpers/blopsleads_helper"

const PERFIL_LABELS = {
  super_admin: "Super Admin",
  admin: "Admin",
  analista: "Analista",
  cliente: "Cliente",
}

const UserProfile = () => {
  document.title = "Perfil | Blops Leads"

  const [usuario, setUsuario] = useState(null)
  const [loadingPerfil, setLoadingPerfil] = useState(true)

  const [senhaAtual, setSenhaAtual] = useState("")
  const [novaSenha, setNovaSenha] = useState("")
  const [confirmarSenha, setConfirmarSenha] = useState("")
  const [loadingSenha, setLoadingSenha] = useState(false)
  const [erro, setErro] = useState("")
  const [sucesso, setSucesso] = useState("")

  const [showSenhaAtual, setShowSenhaAtual] = useState(false)
  const [showNovaSenha, setShowNovaSenha] = useState(false)
  const [showConfirmarSenha, setShowConfirmarSenha] = useState(false)

  useEffect(() => {
    getMe()
      .then(data => setUsuario(data))
      .catch(() => setErro("Não foi possível carregar os dados do perfil."))
      .finally(() => setLoadingPerfil(false))
  }, [])

  const handleAlterarSenha = async e => {
    e.preventDefault()
    setErro("")
    setSucesso("")

    if (novaSenha !== confirmarSenha) {
      setErro("A nova senha e a confirmação não coincidem.")
      return
    }

    if (novaSenha.length < 6) {
      setErro("A nova senha deve ter ao menos 6 caracteres.")
      return
    }

    setLoadingSenha(true)
    try {
      await changePassword({ senhaAtual, novaSenha })
      setSucesso("Senha alterada com sucesso.")
      setSenhaAtual("")
      setNovaSenha("")
      setConfirmarSenha("")
    } catch (err) {
      const msg = err?.response?.data?.message || "Erro ao alterar a senha."
      setErro(msg)
    } finally {
      setLoadingSenha(false)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Blops" breadcrumbItem="Perfil" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {loadingPerfil ? (
                    <div className="text-center py-3">
                      <Spinner color="primary" />
                    </div>
                  ) : (
                    <div className="d-flex align-items-center">
                      <img
                        src={avatar}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail me-3"
                      />
                      <div>
                        <h5 className="mb-1">{usuario?.Name || "—"}</h5>
                        <p className="text-muted mb-1">{usuario?.Email || "—"}</p>
                        <span className="badge bg-primary">
                          {PERFIL_LABELS[usuario?.Perfil] || usuario?.Perfil}
                        </span>
                      </div>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          <h4 className="card-title mb-4">Alterar Senha</h4>

          <Card>
            <CardBody>
              {erro && <Alert color="danger" toggle={() => setErro("")}>{erro}</Alert>}
              {sucesso && <Alert color="success" toggle={() => setSucesso("")}>{sucesso}</Alert>}

              <Form onSubmit={handleAlterarSenha}>
                <Row>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label>Senha atual</Label>
                      <InputGroup>
                        <Input
                          type={showSenhaAtual ? "text" : "password"}
                          value={senhaAtual}
                          onChange={e => setSenhaAtual(e.target.value)}
                          required
                        />
                        <Button
                          type="button"
                          color="light"
                          onClick={() => setShowSenhaAtual(v => !v)}
                          tabIndex={-1}
                        >
                          <FontAwesomeIcon icon={showSenhaAtual ? faEyeSlash : faEye} />
                        </Button>
                      </InputGroup>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label>Nova senha</Label>
                      <InputGroup>
                        <Input
                          type={showNovaSenha ? "text" : "password"}
                          value={novaSenha}
                          onChange={e => setNovaSenha(e.target.value)}
                          required
                        />
                        <Button
                          type="button"
                          color="light"
                          onClick={() => setShowNovaSenha(v => !v)}
                          tabIndex={-1}
                        >
                          <FontAwesomeIcon icon={showNovaSenha ? faEyeSlash : faEye} />
                        </Button>
                      </InputGroup>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label>Confirmar nova senha</Label>
                      <InputGroup>
                        <Input
                          type={showConfirmarSenha ? "text" : "password"}
                          value={confirmarSenha}
                          onChange={e => setConfirmarSenha(e.target.value)}
                          required
                        />
                        <Button
                          type="button"
                          color="light"
                          onClick={() => setShowConfirmarSenha(v => !v)}
                          tabIndex={-1}
                        >
                          <FontAwesomeIcon icon={showConfirmarSenha ? faEyeSlash : faEye} />
                        </Button>
                      </InputGroup>
                    </div>
                  </Col>
                </Row>

                <div className="text-end">
                  <Button type="submit" color="danger" disabled={loadingSenha}>
                    {loadingSenha ? <Spinner size="sm" /> : "Alterar Senha"}
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default UserProfile
